import * as React from "react";

type SearchIconProps = React.SVGProps<SVGSVGElement> & {
  circleColor?: string;
  strokeColor?: string;
};

const SearchIcon = ({
  circleColor = "#1B365E",
  strokeColor = "#ffffff",
  ...props
}: SearchIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M16.6154 10.6154C16.6154 8.83108 15.1689 7.38462 13.3846 7.38462C11.6003 7.38462 10.1538 8.83108 10.1538 10.6154C10.1538 11.5078 10.5145 12.3142 11.1001 12.8999C11.6858 13.4855 12.4922 13.8462 13.3846 13.8462C15.1689 13.8462 16.6154 12.3997 16.6154 10.6154Z"
          fill={circleColor}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM13.3846 5.53846C16.1885 5.53846 18.4615 7.81148 18.4615 10.6154C18.4615 13.4193 16.1885 15.6923 13.3846 15.6923C12.3166 15.6923 11.3247 15.3618 10.507 14.7984L8.03733 17.2681C7.67684 17.6286 7.09239 17.6286 6.7319 17.2681C6.37142 16.9076 6.37142 16.3232 6.7319 15.9627L9.20156 13.493C8.63821 12.6753 8.30769 11.6834 8.30769 10.6154C8.30769 7.81148 10.5807 5.53846 13.3846 5.53846Z"
          fill={circleColor}
        />

        <path
          d="M13.9999 8.34289C13.3403 8.08811 11.9687 8.69532 11.7139 9.35491"
          stroke={strokeColor}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </g>

      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchIcon;
